const promptBeforeUnload = (e: BeforeUnloadEvent) => {
	e = e || window.event;

	if (e) {
		e.returnValue = true;
	}

	return true;
};

export const promptBeforeUnloadListener = () => {
	window.addEventListener('beforeunload', promptBeforeUnload);

	return () => {
		window.removeEventListener('beforeunload', promptBeforeUnload);
	};
};

export const scrollToTop = () => {
	document.body.scrollTop = 0; // For Safari
  	document.documentElement.scrollTop = 0;
};
